import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ConnectStepPlaceholder } from "@/app/onboarding-first-win/steps/connect/connect-step-placeholder";

const searchSchema = z.object({
  jtbd: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/connect"
)({
  validateSearch: searchSchema,
  component: ConnectStepPlaceholder,
});
